import { useGetSellers } from '@/hooks/product/catalog/useGetSellers';
import { sellersResponseToSellerFilterOptions } from '@/hooks/product/catalog/useGetSellers/mapper';
import {
  Autocomplete,
  Checkbox,
  Chip,
  SxProps,
  TextField,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { SellerFilterOption } from './SellerFilterUi';

export function SellerFilter(props: {
  onFilterChanged: (sellersSelected: SellerFilterOption[]) => void;
  sx?: SxProps;
  initialSelected?: SellerFilterOption[];
}) {
  const [value, setValue] = useState<SellerFilterOption[]>(
    props.initialSelected ?? []
  );
  const { data: sellers, isLoading, setFilter } = useGetSellers();

  const chip =
    !value || value?.length === 0 ? (
      <></>
    ) : value.length > 1 ? (
      <Chip label="Varios" />
    ) : (
      <Chip label={value[0].sellerName} />
    );

  const isEditingRef = useRef(false);

  useEffect(() => {
    if (!value) return;
    if (isEditingRef.current) return;
    props.onFilterChanged(value);
  }, [value]);

  const onTextChanged = (newText: string) => setFilter(newText);

  const calculateOptions = () => {
    const sellersUI = sellersResponseToSellerFilterOptions(sellers);

    // Ensure that the selected sellers are always shown as options in the list.
    // Required, otherwise, a warning is shown by MUI
    value.forEach((selectedOption) => {
      if (!sellersUI.some((item) => item.sellerId === selectedOption.sellerId))
        sellersUI.push(selectedOption);
    });
    return sellersUI;
  };

  return (
    <Autocomplete
      sx={{ ...props.sx }}
      multiple
      disableCloseOnSelect
      onOpen={() => {
        isEditingRef.current = true;
      }}
      onClose={() => {
        isEditingRef.current = false;
        props.onFilterChanged(value ?? []);
      }}
      onInputChange={(_e, nv) => onTextChanged(nv)}
      onChange={(_event, value) => setValue(value)}
      value={value}
      isOptionEqualToValue={(option, value) =>
        option.sellerId === value.sellerId
      }
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: chip,
          }}
          placeholder={value?.length ? undefined : 'Vendedor'}
        />
      )}
      getOptionLabel={(option) => option.sellerName}
      options={calculateOptions()}
      filterOptions={(x) => x}
      renderOption={(autocompleteProps, option, { selected }) => {
        const { key, ...optionProps } = autocompleteProps;
        return (
          <li key={key} {...optionProps}>
            <Checkbox style={{ marginRight: 8 }} checked={selected} />
            {option.sellerName}
          </li>
        );
      }}
      loading={isLoading}
    />
  );
}
